module.exports = __webpack_public_path__ + "static/media/0008.6b95d04.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/0008.mp3
// module id = a13A
// module chunks = 0